import React from 'react';
import { filterType } from '../../../../../../../types';
import { FILTER } from '../../../../../../../config/filters';
import Toggle, { TogglePropTypes } from '../toggle';

const ProToggle = ({ filter, ...rest }) => {
    if (!filter) {return null;}

    return (
        <Toggle selectedValue={FILTER.PRO.SELECTED_VALUE}
            title="search_perseus.filters.global.pro.alias"
            text="search_perseus.filters.global.pro.text"
            {...filter}
            {...rest}/>
    );};

ProToggle.propTypes = {
    filter: filterType,
    ...TogglePropTypes
};

export default ProToggle;
